import Cookies, {
  CookieSetOptions,
} from 'universal-cookie';

const millisecondsPerHour = (60 * 60) * 1000;
const maxAge = 24 * millisecondsPerHour;
const expires = new Date();
expires.setDate(expires.getDate() + 1); // Expire cookies in 1 Day

export const cookieOptions: CookieSetOptions = {
  sameSite: 'strict',
  path: '/',
  secure: true,
  httpOnly: false,
  maxAge,
  expires,
};

export const cookies: Cookies = new Cookies(cookieOptions);

export default cookies;
